<template>
  <transition name="lxm-transition-fade" mode="out-in">
    <div v-if="!this.hide && this.content">
      <div class="lxm-dashboard-reg-source-tip"
          :style="style">
        <div class="lxm-dashboard-reg-source-tip__close"
            @click="onCloseClick">X</div>
        <div class="lxm-dashboard-reg-source-tip__content"
            v-html="content">
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="stylus" scoped>
  @import '../../../styles/index.styl'
  close-size = size
  .lxm-dashboard-reg-source-tip
    position: relative
    padding: spacing
    background-color: #f5f5f5
    border: 1px solid #ddd
    border-radius: siz(5)
    margin-bottom: spacing-big
  .lxm-dashboard-reg-source-tip__close
    position: absolute
    top: spacing-small
    right: spacing-small
    font-size: close-size
    line-height: 1
  .lxm-dashboard-reg-source-tip__content
    padding-top: close-size + spacing-small - spacing
</style>

<script>
  export default {
    data () {
      return {
        hide: false
      }
    },
    computed: {
      content () {
        if (window.X && window.X['reg_source'] && window.X['reg_source']['login_text']) {
          return window.X['reg_source']['login_text']
        } else {
          return null
        }
      },
      style () {
        const displayNone = { display: 'none' }
        if (this.hide) {
          return displayNone
        } else if (this.content) {
          return {}
        } else {
          return displayNone
        }
      }
    },
    methods: {
      onCloseClick (e) {
        this.hide = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RegSourceTip.vue?a082a596